import { useState } from "react";
import {Link, useNavigate} from "react-router-dom";
import Modal from "../Modal";

export default function FooterPublic() {
    const navigate = useNavigate();
    const [isOpen,setIsOpen] = useState(false);

    return (
        <footer className="content-footer footer bg-footer-theme">
            <div id="footerNav" className="footer-nav-area">
                <div className="container m-0 h-100 px-0">
                    <div className="suha-footer-nav h-100">
                        <ul className="h-100 d-flex align-items-center justify-content-between ps-0 pe-0">
                            <li onClick={()=>navigate("/user-wallet")}><span><i className="bx bx-wallet"/>کیف پول من</span></li>
                            <li onClick={()=>navigate("/login")}><span><i className="bx bx-plus-circle"/>ثبت تبلیغ</span></li>
                            {/* <li><span><i className="bx bx-file"/>تراکنش ها</span></li> */}
                            <li onClick={()=>navigate("/")}><span ><i className="bx bxs-home"/>خانه</span></li>
                            <li onClick={()=>navigate("/contactus")}><span><i className="bx bx-phone"/>ارتباط با ما</span></li>
                            <li onClick={()=>navigate("/profile-public")}><span><i className="bx bx-user"/>کارسود من</span></li>
                        </ul>
                    </div>
                </div>
            </div>
            <Modal
                style={{backgroundColor: '#555'}}
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                size="xl"
                backColor="#555"
            >
                <div className={"row"}>

                    <div className="col-xl-12">

                        <div className="col-12 mb-2">
                            <Link to="/my-advertisement/new" onClick={()=>setIsOpen(false)} className="btn btn-warning me-3  ms-auto w-100 bg-warning"> <i className="bx bx-plus-circle"/> ثبت تبلیغ جدید</Link>
                            {/* <button style={{marginBottom: '6px'}} className="btn btn-primary me-3  ms-auto w-100 bg-primary" type={"button"}
                                    onClick={()=>navigate("/my-advertisement/list?page=1&pageSize=20")}> + ثبت تبلیغ جدید
                            </button> */}
                        </div>
                        <div className="col-12 mb-1">
                            <Link to="/my-advertisement/list?page=1&pageSize=20" onClick={()=>setIsOpen(false)} className="btn btn-warning me-3  ms-auto w-100 bg-warning">تبلیغات من</Link>
                            {/* <button className="btn btn-primary me-3  ms-auto w-100 bg-primary" type={"button"}
                                    onClick={()=>navigate("/my-advertisement/new")}
                                    > تبلیغات من
                            </button> */}
                        </div>
                    </div>

                </div>
            </Modal>
        </footer>
    )
}